import { render, staticRenderFns } from "./shortMessage.vue?vue&type=template&id=732a8046&scoped=true"
import script from "./shortMessage.vue?vue&type=script&lang=js"
export * from "./shortMessage.vue?vue&type=script&lang=js"
import style0 from "./shortMessage.vue?vue&type=style&index=0&id=732a8046&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../../node_modules/.store/vue-loader@15.11.1/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "732a8046",
  null
  
)

export default component.exports